import { TipoLicenca } from 'enums/tipo-licenca.enum';

export interface ContaComLicenca {
  pacAutonomo?: boolean;
  tipoLicenca?: string | TipoLicenca;
}

export interface FlagOcultacao {
  enabled: boolean;
}

export function isTipoLicenca100Autonomo(tipoLicenca: string | TipoLicenca): boolean {
  if (!tipoLicenca) {
    return false;
  }
  return String(tipoLicenca).toUpperCase() === TipoLicenca.PAC_AUTONOMO;
}

export function isContaPacAutonoma(conta: ContaComLicenca): boolean {
  if (!conta) {
    return false;
  }
  if (typeof conta.pacAutonomo === 'boolean') {
    return conta.pacAutonomo;
  }
  return isTipoLicenca100Autonomo(conta.tipoLicenca);
}

export function deveOcultarParaPac(
  flagConta: FlagOcultacao,
  conta: ContaComLicenca
): boolean {
  if (flagConta) {
    return flagConta.enabled;
  }
  return isContaPacAutonoma(conta);
}
